import React, { memo } from 'react';
import { View } from 'react-native';
import { Text } from '@redlink/components/atoms';
import { ImageCircularUploaderSimple } from '@redlink/components/muscles';
import { createUseStyle } from '@redlink/assets/styles';

export const ImageCircularUploader = memo(
  ({
    disabled = false,
    title,
    description,
    onUpload,
    value,
    thumbnail,
  }) => {
    const { styles } = useStyle();

    return (
      <View style={styles.container}>
        <View style={styles.textsContainer}>
          <Text style={styles.titleText}>{title}</Text>
          <Text style={styles.descriptionText}>{description}</Text>
        </View>
        <View>
          <ImageCircularUploaderSimple
            thumbnail={thumbnail}
            value={value}
            onUpload={onUpload}
            disabled={disabled}
          />
        </View>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
    paddingVertical: 4,
    flexDirection: 'row',
  },
  textsContainer: {
    flex: 1,
    paddingEnd: 8,
  },
  descriptionText: {
    fontSize: 12,
    lineHeight: 15,
    marginVertical: 8,
    color: colors.gray21,
  },
  titleText: {
    color: colors.black,
    fontSize: 14,
  },
}));
